
import { pageContext, userContext } from 'context'
import moment from 'moment-timezone'

class User {
    constructor(props){
        let updatedProps = props || {};
        this.uid = updatedProps.uid

        // Info
        this.first_name = updatedProps.first_name
        this.last_name = updatedProps.last_name
        this.email = updatedProps.email
        this.provider = updatedProps.provider
        this.picture = updatedProps.picture
        this.credential = updatedProps.credential
        this.created = updatedProps.created

        // Preferences
        this.theme = updatedProps.theme || 'Dark'
        this.full_width = updatedProps.full_width || false
        this.item_divider = updatedProps.item_divider || false
        this.show_completed = updatedProps.show_completed || false
        this.show_archived = updatedProps.show_archived || false
        this.setup_completed = updatedProps.setup_completed || false
        this.app_notifications = updatedProps.app_notifications || false
        this.desktop_notifications = updatedProps.desktop_notifications

        // Time preferences
        this.timezone = updatedProps.timezone || moment.tz.guess()

        // Pages
        this.inboxID = updatedProps.inboxID
        this.activePageID = updatedProps.activePageID || pageContext.MODULES.HOME
        this.activePageType = updatedProps.activePageType || pageContext.TYPES.MODULES
        this.activePages = updatedProps.activePages || []
        this.archivePages = updatedProps.archivePages || []
        this.sharedPages = updatedProps.sharedPages || []

        // Subscriptions
        this.subscription_plan = updatedProps.subscription_plan || userContext.PLANS.BETA
        // this.subscription_plan = updatedProps.subscription_plan || userContext.PLANS.PERSONAL
        // this.subscription_plan = userContext.PLANS.PREMIUM
        this.subscription_frequency = updatedProps.subscription_frequency
        this.subscription_end = updatedProps.subscription_end
        this.subscription_start = updatedProps.subscription_start
        this.subscription_status = updatedProps.subscription_status

        // Calendar settings
        this.calendar_show_completed = updatedProps.calendar_show_completed
        this.calendar_show_weekends = updatedProps.calendar_show_weekends
        this.calendar_step_size = updatedProps.calendar_step_size || '30'
        // this.calendar_step_size = '30'
        this.calendar_initial_time = updatedProps.calendar_initial_time || '8am'

        // Misc
        this.show_loginModal = updatedProps.show_loginModal
        this.show_updatesModal = updatedProps.show_updatesModal

    }
}

export default User